import * as tslib_1 from "tslib";
import { SearchField } from '@nextiva/next-ui';
import React, { PureComponent } from 'react';
import Styles from "./Search.css";

var Search =
/** @class */
function (_super) {
  tslib_1.__extends(Search, _super);

  function Search() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onChange = function (event) {
      var onChange = _this.props.onChange; //on delete button click event is undefined

      if (event) {
        onChange(event.target.value);
      } else {
        onChange('');
      }
    };

    return _this;
  }

  Search.prototype.render = function () {
    var searchValue = this.props.searchValue;
    return React.createElement("div", {
      className: Styles.search
    }, React.createElement(SearchField, {
      "data-test": "list-search-field",
      placeholder: "Search",
      onChange: this.onChange,
      value: searchValue
    }));
  };

  return Search;
}(PureComponent);

export default Search;